import React from 'react';

export const Page404 = () => {
	return (
		<div className='page404-container'>
			<div className='page404-container-div'>
				<h1>404 Page does not exist</h1>
			</div>
		</div>
	);
};
